import React, { useState, useEffect, useRef } from "react";
import { Button, Col, Row, Layout, Space, Affix, Tabs, Typography } from "antd";
const { Header, Content, Footer } = Layout;

const EMILayout = ({
    show = true,
    children
}) => {
    const { Title } = Typography;

    const googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
            {
                pageLanguage: "zh-TW",
                autoDisplay: false,
                includedLanguages: 'en,zh-TW',
                // layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE

            },
            "google_translate_element"
        );
    };
    useEffect(() => {
        var addScript = document.createElement("script");
        addScript.setAttribute(
            "src",
            "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
        );
        document.body.appendChild(addScript);
        window.googleTranslateElementInit = googleTranslateElementInit;
    }, []);
    // const EMILayout = ({ children }) => {

    return (
        <><Layout className="layout" style={{ overflow: 'hidden' }} >
            {/* <Header
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#ffffff'
                }}
            >
                首頁
            </Header> */}
            <Content>

                <div
                    className="site-layout-content"
                >
                    {children}
                </div>
            </Content>
            <Footer
                style={{
                    // textAlign: 'center',
                    padding: '32px 0px',
                    backgroundColor: '#00000033',
                    // overflow: 'hidden',
                }}
            >
                {/* <Row justify={'center'}>
                    <Col span={10}>
                        <Row gutter={[0, 16]}>
                            <Col span={24}>
                                <div style={{ height: '50px', width: '200px', backgroundColor: '#00000088' }}></div>
                            </Col>
                            <Col span={24} >高株市左谷区文学路2813</Col>
                            <Col span={24} >香業時間：週一至興五 09:00-17:30</Col>
                            <Col span={24} >行勠胃銩，0965219929</Col>
                            <Col span={24} >粥終信箱：ig90617532gmail.con</Col>
                        </Row>
                    </Col>
                    <Col span={8}>
                        <Row gutter={[8, 8]}>
                            <Col span={24}>
                                <Row gutter={[8, 8]}>
                                    <Col style={{ fontSize: '2em', cursor: 'pointer' }} ><FacebookFilled /></Col>
                                    <Col style={{ fontSize: '2em', cursor: 'pointer' }} ><InstagramFilled /></Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <div style={{ height: '200px', width: '200px', backgroundColor: '#00000088' }}>

                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row> */}
                <Row gutter={[0, 30]} >
                    {/* <Col span={24}>
                        <Row justify={'center'} gutter={[10, 30]} >
                            <Col>
                                行事曆
                            </Col>
                            <Col>
                                行事曆
                            </Col>
                            <Col>
                                行事曆
                            </Col>
                            <Col>
                                行事曆
                            </Col>
                            <Col>
                                行事曆
                            </Col>
                            <Col>
                                行事曆
                            </Col>
                            <Col>
                                行事曆
                            </Col>
                            <Col>
                                行事曆
                            </Col>
                            <Col>
                                行事曆
                            </Col>
                        </Row>
                    </Col> */}
                    <Col lg={{ span: 24 }} xs={{ span: 0 }}>
                        <Row justify={'center'} gutter={[0, 30]} >
                            <Col flex={'1'} style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
                                
                                <div style={{ padding: '10px 0' }} >
                                    <span>80201高雄市苓雅區和平一路116號</span>
                                </div>
                                {/* <div style={{ padding: '10px 0' }} >
                                    <span>營業時間：週一至週五 09:00-17:30</span>
                                </div> */}

                                <div style={{ padding: '10px 0' }} >
                                    <span>中心電話：(07)717-2930 轉3902或3921或3922</span>
                                </div>
                                <div style={{ padding: '10px 0' }} >
                                    <span>意見反應： nknuiteach@mail.nknu.edu.tw</span>

                                </div>

                            </Col>
                            <Col style={{ padding: '0 25px' }} />
                            <Col flex={'1'} style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }} >
                                <Row gutter={10}>
                                    <Col>
                                        <div id="google_translate_element">

                                        </div>
                                    </Col>
                                    <Col>
                                        <img
                                            alt="Facebook"
                                            onClick={e => window.open('https://www.facebook.com/NKNUiteach.EMITaiwanTeachForTheWorld/')}
                                            // onClick={e => window.open('https://www.facebook.com/jushengco/about')}//ju
                                            style={{ width: '40px', height: ' 40px', objectFit: 'cover', cursor: 'pointer' }}
                                            fetchpriority="high" src="/cram_school/facebook.png">
                                        </img>
                                    </Col>
                                    <Col>
                                        <img
                                            alt="line"
                                            onClick={e => window.open('https://line.me/ti/g2/YS7ypv8Gk-T63yG2O4YsHbUK0wZBOM3Uk-MtdQ?utm_source=invitation&utm_medium=link_copy&utm_campaign=default')}
                                            // onClick={e => window.open('')}
                                            style={{ width: '40px', height: ' 40px', objectFit: 'cover', cursor: 'pointer' }}
                                            fetchpriority="high"
                                            src="/cram_school/line.png">

                                        </img>
                                    </Col>
                                    <Col>
                                        <img
                                            alt="Instagram"
                                            style={{ width: '40px', height: ' 40px', objectFit: 'cover', cursor: 'pointer' }}
                                            fetchpriority="high"
                                            src="/cram_school/instagram.png">

                                        </img>
                                    </Col>
                                    <Col>
                                        <img
                                            alt="YouTube "
                                            style={{ width: '40px', height: ' 40px', objectFit: 'cover', cursor: 'pointer' }}
                                            fetchpriority="high" src="/cram_school/youtube.png">
                                        </img>
                                    </Col>

                                </Row>
                                <div style={{ border: '1px inset #000', width: '30vw', margin: '10px 0' }} />
                                <Row style={{ color: '#000', }} gutter={[20, 10]} justify={'start'} >
                                    <Col>
                                        <Typography.Text>
                                            緊急聯絡
                                        </Typography.Text>
                                    </Col>
                                    <Col>
                                        <div style={{ border: '1px solid #000', height: '100%' }} />
                                    </Col>
                                    <Col>
                                        地圖與交通
                                    </Col>
                                    <Col>
                                        <div style={{ border: '1px solid #000', height: '100%' }} />
                                    </Col>
                                    <Col>
                                        隱私權及資訊安全政策
                                    </Col>
                                    <Col span={24}>
                                    {/* <div style={{ padding: '10px 0' }} > */}
                                    {/* <Title level={2}>洰晟數位智慧</Title> */}
                                {/* </div> */}
                                    </Col>
                                    
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={{ span: 0 }} xs={{ span: 24 }}>
                        <Row justify={'center'} gutter={[0, 30]} >
                            <Col span={24} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ padding: '10px 0' }} >
                                    {/* <Title level={3}>洰晟數位智慧</Title> */}
                                </div>
                                <div style={{ padding: '10px 0' }} >
                                    <span>80201高雄市苓雅區和平一路116號
</span>
                                </div>
                                {/* <div style={{ padding: '10px 0' }} >
                                    <span>營業時間：週一至週五 09:00-17:30</span>
                                </div> */}

                                <div style={{ padding: '10px 0' }} >
                                    <span>中心電話：(07)717-2930 轉3902或3921或3922</span>

                                </div>
                                <div style={{ padding: '10px 0' }} >
                                    <span>意見反應： nknuiteach@mail.nknu.edu.tw</span>

                                </div>

                            </Col>
                            <Col span={24} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                                <Row gutter={10}>
                                    <Col>
                                        <div id="google_translate_element">

                                        </div>
                                    </Col>
                                    <Col>
                                        <img
                                            alt="Facebook"
                                            onClick={e => window.open('https://www.facebook.com/jushengco/about')}//ju
                                            style={{ width: '40px', height: ' 40px', objectFit: 'cover', cursor: 'pointer' }}
                                            fetchpriority="high" src="/cram_school/facebook.png">
                                        </img>
                                    </Col>
                                    <Col>
                                        <img
                                            alt="line"
                                            onClick={e => window.open('https://line.me/ti/g2/YS7ypv8Gk-T63yG2O4YsHbUK0wZBOM3Uk-MtdQ?utm_source=invitation&utm_medium=link_copy&utm_campaign=default')}
                                            style={{ width: '40px', height: ' 40px', objectFit: 'cover', cursor: 'pointer' }}
                                            fetchpriority="high"
                                            src="/cram_school/line.png">

                                        </img>
                                    </Col>
                                    <Col>
                                        <img
                                            alt="Instagram"
                                            style={{ width: '40px', height: ' 40px', objectFit: 'cover', cursor: 'pointer' }}
                                            fetchpriority="high"
                                            src="/cram_school/instagram.png">

                                        </img>
                                    </Col>
                                    <Col>
                                        <img
                                            alt="YouTube "
                                            style={{ width: '40px', height: ' 40px', objectFit: 'cover', cursor: 'pointer' }}
                                            fetchpriority="high" src="/cram_school/youtube.png">
                                        </img>
                                    </Col>
                                    {/* <Col>
                                        <div style={{ height: '30px', width: '30px', borderRadius: '50%', backgroundColor: '#fff' }} />
                                    </Col>
                                    <Col>
                                        <div style={{ height: '30px', width: '30px', borderRadius: '50%', backgroundColor: '#fff' }} />
                                    </Col>
                                    <Col>
                                        <div style={{ height: '30px', width: '30px', borderRadius: '50%', backgroundColor: '#fff' }} />
                                    </Col>
                                    <Col>
                                        <div style={{ height: '30px', width: '30px', borderRadius: '50%', backgroundColor: '#fff' }} />
                                    </Col>
                                    <Col>
                                        <div style={{ height: '30px', width: '30px', borderRadius: '50%', backgroundColor: '#fff' }} />
                                    </Col>
                                    <Col>
                                        <div style={{ height: '30px', width: '80px', backgroundColor: '#fff' }} />
                                    </Col> */}
                                </Row>
                                <div style={{ border: '1px inset #000', width: '30vw', margin: '10px 0' }} />
                                <Row style={{ color: '#000', }} gutter={[20, 10]} justify={'center'} >
                                    <Col span={24} style={{ textAlign: 'center' }} >
                                        緊急聯絡
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'center' }} >
                                        地圖與交通
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'center' }} >
                                        隱私權及資訊安全政策
                                    </Col>
                                    <Col span={24} ></Col>
                                    
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Footer>
        </Layout>
        </>
    )
}
export default EMILayout;
